import { render, staticRenderFns } from "./InnerLoading.vue?vue&type=template&id=5b5668ba&scoped=true&"
import script from "./InnerLoading.vue?vue&type=script&lang=ts&"
export * from "./InnerLoading.vue?vue&type=script&lang=ts&"
import style0 from "./InnerLoading.vue?vue&type=style&index=0&id=5b5668ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5668ba",
  null
  
)

export default component.exports